import(/* webpackMode: "eager" */ "/home/ubuntu/app/hellojob-pro/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CtaNhaTuyenDung"] */ "/home/ubuntu/app/hellojob-pro/src/components/cta-nha-tuyen-dung.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaViecLamGoiY"] */ "/home/ubuntu/app/hellojob-pro/src/components/cta-viec-lam-goi-y.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaViecLamPhuHop"] */ "/home/ubuntu/app/hellojob-pro/src/components/cta-viec-lam-phu-hop.tsx");
